export default "__VITE_ASSET__019ae1c7__"